import { Divider } from "@mui/material";
import React from "react";

const DeletePopUp = ({
  isClickedToDelete,
  setIsClickedToDelete,
  onClickDelete,
  title,
  id,
}) => {
  return (
    <div
      className={`delete-user-popup ${
        isClickedToDelete && "show-delete-user-popup"
      }`}
    >
      <div className="delete-pop-up-box">
        <h4>Are you really want to delete this {title}?</h4>
        <Divider />
        <div className="btn-confirm-delete-box">
          <button onClick={() => setIsClickedToDelete(false)}>Cancel</button>
          <button
            onClick={() => {
              onClickDelete(id);
              setIsClickedToDelete(false);
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopUp;
